import { createSelector } from '@ngrx/store';

import * as Utils from '@shared/core/utils';
import * as Statics from '@shared/core/statics';

import { onlineOrderState } from '../root';
import { hasMetMinimumOrderValueCriteria } from '../hasMetMinimumOrderValueCriteria';

export const deliveryNotAvailableError = createSelector(onlineOrderState, hasMetMinimumOrderValueCriteria, (onlineOrder) => {
    const text = new Statics.TextsStatic().current;

    return Utils.Messages.mapErrors({
        deliveryNotAvailable: text.errors.deliveryCurrentlyUnavailable,
    });
});
